import { Component, OnInit, Input, ViewChild, TemplateRef  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';

import { AddEditCashReceiptComponent } from './addEditCashReceipt.component';
import { CashReceiptModel } from '../../../model/index';
import { CashReceiptService, SubscribeService  } from '../../../services/index';

@Component({
    selector: 'cashreceipt-tab',
    templateUrl: './cashReceipt.component.html',
})

export class CashReceiptComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public cashreceipt: any[] = [];

    isLoadMask: Promise<any>;
    //cashreceipt: CashReceiptModel[];
    isLoading: boolean = false;

    constructor(private cashReceiptService: CashReceiptService, public subscribeService: SubscribeService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'desc'
    };
    filterData = {
        "search_name": "",
        "from_date": new Date(),
        "to_date": new Date()
    };
     printConfig: any = {
        title: this.title,
        columns: [],
        rows: []
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    toggleCol = [];

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Bill No', prop: 'auto_no', width: 80, minWidth: 80, maxWidth: 80 },
            { name: 'Date', prop: 'disp_date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Ledger Name', prop: 'client_no', width: 250, minWidth: 250, maxWidth: 250 },
            { name: 'Action', prop: 'sno', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
        this.subscribeService.publishReloadSalesBillentryListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getCashReceiptList();
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getCashReceiptList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_name": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        this.filterPanel.close();
        this.getCashReceiptList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCashReceiptList();
    }
    getCashReceiptList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                search_name: this.filterData['search_name'],
                from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
                from_page: this['params']['tabParams']
            };

        this.isLoadMask = this.cashReceiptService
            .getCashReceiptList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.cashreceipt = res.data;
            });
    }


    addSalesbillentry(mode: string, row: any): void {

        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'bill_id': '',
                'mode': mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddEditCashReceiptComponent', row, this['params']['tabParams']);
    }

    onDeleteCashReceiptentry(row: any): void {
        let that = this,
        params = {
            bill_id: row.bill_id,
            client_id: row.client_id,
            bill_type: row.bill_type,
            type: row.type
        };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Cash Receipt Details, No - ' + row['auto_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.loadingIndicator = true;
            that.isLoadMask = that.cashReceiptService
                .deleteCashReceiptentry(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getCashReceiptList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
     @ViewChild('printPage') printPage;
    onPrintReport(row: any) {
        let that = this;
        this.printConfig = {
            type: this.title,
            title: 'SOUNDS GOOD HEARING CARE',
            subTitle: this.title,
            rows: row,
            columns: that.columns
            /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
             todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
        }

        setTimeout(() => {
            that.printPage.printPreview();
        }, 100);
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashReceipt/cashReceipt.component.ts